import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { memo } from 'react';
import times from 'lodash/times';
import Cell from './Cell';
const Loader = ({ itemsNumber = 10 })=>/*#__PURE__*/ _jsx(_Fragment, {
        children: times(itemsNumber, (idx)=>/*#__PURE__*/ _jsx(Cell, {}, `skeleton-kpis-${idx}`))
    });
export default /*#__PURE__*/ memo(Loader);
